import { testimonials } from '@/mocks/data';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            用户口碑
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自真实用户的评价，是他们让我们不断前行
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((item, index) => (
            <div key={index} className="bg-white rounded-lg p-5">
              <div className="flex items-center gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-4">
                "{item.content}"
              </p>
              <div>
                <p className="text-sm font-semibold text-foreground-800">{item.name}</p>
                <p className="text-xs text-foreground-400">{item.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}